module finadai.directives {

  export function permissionRequiredDirective(authService: services.AuthService): ng.IDirective{
    return {
      restrict: 'A',
      link: (scope, element, atts: any) => {
        
        authService.isLoggedIn().then(response => {
          var results = response.operations.filter(item => (atts.permissionRequired.split(',').indexOf(item) >= 0));
          if(results.length == 0){
            element.remove();
          }
        });
      }
    }
  }

  export function notHasPermissionDirective(authService: services.AuthService): ng.IDirective{
    return {
      restrict: 'A',
      link: (scope, element, atts: any) => {
        
        authService.isLoggedIn().then(response => {
          var results = response.operations.filter(item => (atts.notHasPermission.split(',').indexOf(item) >= 0));
          if(results.length > 0){
            element.remove();
          }
        });
      }
    }
  }

}